




























import { Component, Vue } from 'vue-property-decorator';
import PageHeaderError from '@/components/PageHeaderError.vue';
import ColorButton from '@/components/ColorButton.vue';
import { OsType, getOSType } from '@/util/device';

@Component({
  components: {
    PageHeaderError,
    ColorButton
  }
})
export default class Page extends Vue {
  private get code(): string {
    if (!this.$store.getters['support/isOS']) return 'os';
    if (!this.$store.getters['support/isBrowser']) return 'browser';
    if (!this.$store.getters['support/isCamera']) return 'camera';
    return '';
  }

  private get messages(): string[] {
    const key: string = `componentsUnsupportView.${this.code}.message`;
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get details1(): string[] {
    const osType = getOSType();
    const key: string = `componentsUnsupportView.${this.code}.detail1`;
    if (this.code === 'camera') {
      let browser: string = this.$t('componentsUnsupportView.defaultBrowser') as string;
      if (osType === OsType.iOS || osType === OsType.iPad) browser = 'Safari';
      if (osType === OsType.Android) browser = 'Chrome';
      return [this.$t(`${key}${this.url ? 'A' : 'B'}`, { browser }) as string];
    } else {
      return (this.$t(key) as { [key: number]: string }) as string[];
    }
  }

  private get details2(): string[] {
    const key: string = `componentsUnsupportView.${this.code}.detail2`;
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get url(): string {
    if (this.code === 'camera') return this.$store.getters['auth/requestURL'];
    if (this.code === 'browser') return this.$store.getters['auth/requestURL'];
    return '';
  }

  mounted(): void {
    window.addEventListener('copy', this.handleCopy);
  }

  beforeDestroy(): void {
    window.removeEventListener('copy', this.handleCopy);
  }

  private onCopy(): void {
    const field: HTMLDivElement = this.$el
      .getElementsByClassName('error-page-contents-hidden')
      .item(0) as HTMLDivElement;

    const range: Range = document.createRange();
    const selection: Selection | null = window.getSelection();
    range.selectNode(field);
    selection && selection.removeAllRanges();
    selection && selection.addRange(range);
    document.execCommand('Copy');
    selection && selection.removeAllRanges();
  }

  private handleCopy(): void {
    const selection: Selection | null = window.getSelection();
    if (selection === null) return;
    var copied = selection.toString();
    if (copied.trim() !== this.url) return;

    this.$buefy.toast.open({
      message: this.$tc('componentsUnsupportView.copied'),
      type: 'is-info',
      position: 'is-bottom'
    });
  }
}
